const HOST = process.env.VUE_APP_API_URL
export default {
	endPoint: `${HOST}/api`,
	typeAuthorization: 'Bearer',
	storageTokenKeyName: 'accessToken',
	storageRefreshTokenKeyName: 'refreshToken',
}
